import { regularFont, color } from './helpers'

const globalStyles = {
  '@global': {
    /* reset part */
    '*': {
      margin: 0,
      padding: 0,
      outline: 'none',
      border: 'none',
      textDecoration: 'none',
      boxSizing: 'border-box',
      listStyle: 'none',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      '-webkit-text-size-adjust': 'none',
      '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
      '-webkit-font-smoothing': 'subpixel-antialiased',
    },

    'button, input.submit, input[type=submit]': {
      cursor: 'pointer'
    },

    'strong, h1, h2, h3, h4, h5, h6': {
      fontWeight: 'normal'
    },

    /* end reset part */

    'html, body': {
      minHeight: '100%'
    },

    body: {
      ...regularFont(),
      ...color('textDefault'),
      fontSize: '100%', // important setup for the font size helpers
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },

    '.intl-tel-input .country-list': {
      zIndex: 10
    }
  }
}

export default globalStyles
